import NewReleasesRoundedIcon from '@mui/icons-material/NewReleasesRounded';
import PropTypes from 'prop-types';
import { navStatusList } from '../../utils/page';

export function NavIcon({ status }) {
	if (status === navStatusList.needChecked) return <NewReleasesRoundedIcon color="info" />;
	if (status === navStatusList.none) return <></>;
	return <></>;
}
NavIcon.propTypes = {
	status: PropTypes.string,
};
